import { useFetch } from 'hooks';
import { MfaEnrollment } from 'types/interfaces/user/MFAEnrollment';

interface MfaApiFunctions {
  getMfaEnrollmentAsync: () => Promise<MfaEnrollment>;
  skipMfaAsync: () => Promise<void>;
  acceptMfaAsync: () => Promise<void>;
}

export const useMfaFunctions = (): MfaApiFunctions => {
  const { get, post } = useFetch();

  async function remoteGetMfaInfoAsync(): Promise<MfaEnrollment> {
    const url = `/usermanagement/mfa-enrollments`;
    const res = await get(url);

    if (res.status !== 200) {
      throw new Error('Something went wrong');
    }

    const data = await res?.json();
    const dataTyped = data as { enrollments: MfaEnrollment[] };
    const enrollment =
      !dataTyped?.enrollments || dataTyped.enrollments.length === 0
        ? null
        : data.enrollments[0];

    return enrollment;
  }

  async function remotelySkipMFAAsync(): Promise<void> {
    const url = `/usermanagement/skip-mfa`;
    await post(url, {});
  }

  async function remotelyAcceptMFAAsync(): Promise<void> {
    const url = `/usermanagement/accept-mfa`;
    await post(url, {});
  }

  return {
    getMfaEnrollmentAsync: remoteGetMfaInfoAsync,
    skipMfaAsync: remotelySkipMFAAsync,
    acceptMfaAsync: remotelyAcceptMFAAsync,
  };
};

export default useMfaFunctions;
